<style lang="scss" scoped>
.mobile-login {
  .captcha-box {
    padding-right: 90px;
    position: relative;

    &__handler {
      position: absolute;
      right: 0;
      top: 0;

      &-img {
        border: solid 1px #dedede;
        border-radius: 3px;
        height: 35px;
        margin-top: -2px;
        vertical-align: middle;
        width: 100%;
      }

      &-text {
        display: inline-block;
        font-size: 12px;
        width: 60px;
      }
    }
  }

  .switch-button {
    color: #28e;
    cursor: pointer;
    left: 100%;
    margin-left: 16px;
    position: absolute;
    text-decoration: underline;
    top: 0;
    white-space: nowrap;

    @media screen and (max-device-width: 400px) {
      top: -85px;
      left: 0;
    }
  }
}
</style>
<template>
    <el-form
        class="mobile-login"
        ref="formData"
        :model="formData"
        :rules="formDataRule"
        action="."
        label-width="180px"
        :label-position="labelPosition"
        style="margin-top: 16px;">
        <el-form-item
            v-if="isEmailAuth"
            :label="$t(pageType === 'mobile' ? 'i18n.newEmail' : 'i18n.email')"
            prop="email">
            <el-input
                v-focus
                v-model.trim="formData.email"
                :placeholder="$t('i18n.emailPlaceholder')"
                maxlength="254"></el-input>
            <a
                v-if="isResetOrUnfreezePage"
                class="switch-button"
                @click="switchAuthMode">{{ $t('i18n.switchToPhoneAuthentication') }}</a>
        </el-form-item>
        <el-form-item
            v-else
            :label="$t(pageType === 'mobile' ? 'i18n.newPhone' : 'i18n.phone')"
            prop="mobile">
            <el-input
                v-focus
                v-model.trim="formData.mobile"
                :placeholder="$t('i18n.phonePlaceholder')"
                maxlength="11">
                <country-calling-code-picker
                    v-model="formData.areaCode"
                    slot="prepend"></country-calling-code-picker>
            </el-input>
            <a
                v-if="isResetOrUnfreezePage"
                class="switch-button"
                @click="switchAuthMode">{{ $t('i18n.switchToEmailAuthentication') }}</a>
        </el-form-item>
        <!--
        <el-form-item prop="geetest" v-show="false">
            <sweet-gt-captcha
                ref="geetest"
                :action="g.action"
                :width="'100%'"
                :product="'bind'"
                @onClose="gOnClose"
                @onError="gOnError"
                @onReset="gReset"
                @initError="gInitError"
                @onSuccess="gOnSuccess"
                :lang="$store.state.language" v-if="refreshGeetest"></sweet-gt-captcha>
        </el-form-item>
        -->
        <el-form-item
            v-if="isEmailAuth"
            :label="$t('i18n.emailcode')"
            prop="emailcode"
            style="margin-bottom: 20px;">
            <div class="captcha-box" style="padding-right: 92px;">
                <div class="captcha-box__input">
                    <el-input
                        @keyup.13.native="onKeyup"
                        ref="emailCpt"
                        v-model.trim="formData.emailcode"
                        :placeholder="$t('i18n.cptEmailPlaceholderTwo')"
                        maxlength="6"></el-input>
                </div>
                <div class="captcha-box__handler">
                    <el-button
                        style="padding: 9px 10px;"
                        @click="getEmailCaptcha"
                        :disabled="captchaDisabled">
                        <span v-if="!captchaLoading">
                            <span
                                class="captcha-box__handler-text"
                                v-t="'i18n.sendCapt'"></span>
                        </span>
                        <span
                            class="captcha-box__handler-text"
                            v-else>{{captchaText}}</span>
                    </el-button>
                </div>
            </div>
        </el-form-item>
        <el-form-item
            v-else
            :label="$t('i18n.smscode')"
            prop="smscode"
            style="margin-bottom: 20px;">
            <div class="captcha-box" style="padding-right: 92px;">
                <div class="captcha-box__input">
                    <el-input
                        @keyup.13.native="onKeyup"
                        ref="mobileCpt"
                        v-model.trim="formData.smscode"
                        :placeholder="$t('i18n.cptPhonePlaceholderTwo')"
                        maxlength="6"></el-input>
                </div>
                <div class="captcha-box__handler">
                    <el-button
                        style="padding: 9px 10px;"
                        @click="getPhoneCaptcha"
                        :disabled="captchaDisabled">
                        <span v-if="!captchaLoading">
                            <span
                                class="captcha-box__handler-text"
                                v-t="'i18n.sendCapt'"></span>
                        </span>
                        <span
                            class="captcha-box__handler-text"
                            v-else>{{captchaText}}</span>
                    </el-button>
                </div>
            </div>
        </el-form-item>
    </el-form>
</template>
<script>
import sweetGtCaptcha from 'sweet-gt-captcha';
/**
 * 密码重置 账号解冻 手机号修改共用组件
 */
export default {
  name: 'mobileLogin',
  // components: {
  //   sweetGtCaptcha,
  // },
  props: {
    formData: {
      type: Object,
    },
    formDataRule: {
      type: Object,
    },
  },
  data() {
    const gBase = {
      action: '/api/deed_captcha',
      // initResult: '',
      validate: false,
    };
    return {
      labelPosition: window.matchMedia('(min-width: 400px)').matches ? 'right' : 'top',
      captchaDisabled: false,
      captchaLoading: false,
      captchaImgVersion: new Date().getTime(),
      captchaText: '',
      loading: false,
      gError: false,
      // refreshGeetest: true,
      // gBase,
      // g: JSON.parse(JSON.stringify(gBase)),
    };
  },
  computed: {
    /**
         * 图片验证码地址
         * @returns {string} 地址
         */
    imgSrc() {
      return `/api/captcha?v=${this.captchaImgVersion}`;
    },

    /**
         * 是否启用邮箱验证
         * @returns {boolean} 是否
         */
    isEmailAuth() {
      return this.$route.query.auth === 'email';
    },

    /**
         * 是否是密码重置或帐号解冻页面
         * @returns {boolean} 是否
         */
    isResetOrUnfreezePage() {
      return /reset|unfreeze/.test(this.$route.params.type);
    },

    /**
         * 页面类型
         * @returns {string} 类型
         */
    pageType() {
      return this.$route.params.type;
    },
  },
  methods: {
    getCaptchaImgVersion() {
      this.captchaImgVersion = new Date().getTime();
    },

    getPhoneCaptcha() {
      this.$refs.formData.validateField('mobile', (error) => {
        if (error) {
          return;
        }

        if (this.isEmailAuth) {
          this.sendEmailAjax();
        } else {
          this.sendPhoneAjax();
        }

        // this.$refs.geetest.verify();
      });
    },
    sendPhoneAjax() {
      const { areaCode, mobile } = this.formData;
      const params = {
        areaCode,
        mobile,
        // challenge: this.g.initResult.geetest_challenge,
      };
      // 如果是账号解冻或密码重置组件增加stype作为操作行为区分
      if (this.isResetOrUnfreezePage) {
        params.stype = 1;
        if (this.pageType === 'unfreeze') {
          params.stype = 2;
        }
      }
      this.$api[this.pageType === 'mobile' ? 'mobileUpdate' : 'mobileAuth'].sendMessage(params).then((res) => {
        this.$message.success(this.$t(`ajax.${res.code}`));
        this.$refs.mobileCpt.focus();
        this.countDown(60, this.captchaText);
        this.captchaLoading = true;
      }).catch((err) => {
        if (err.CODE === 'GT_VERIFY_STATUS_NO_EXIST') {
          this.refreshInitGeetest();
        }
        this.clearCountDown(this.$t('i18n.sendCapt'));
      });
    },
    countDown(count, text) {
      this.captchaText = count;
      this.captchaDisabled = true;
      if (this.intervalId) clearInterval(this.intervalId);
      this.intervalId = setInterval(() => {
        if (count !== 0) {
          count--;
          this.captchaText = count;
        } else {
          this.captchaText = text;
          this.captchaDisabled = false;
          this.captchaLoading = false;
        }
      }, 1000);
    },

    clearCountDown() {
      clearInterval(this.intervalId);
      this.captchaText = '';
      this.captchaLoading = false;
      this.captchaDisabled = false;
    },

    onKeyup() {
      if (this.pageType === 'mobile') {
        // 修改手机号
        this.$emit('keyup-submit');
      } else if (this.pageType === 'reset' || this.pageType === 'unfreeze') {
        // 密码重置及帐号解冻
        this.$emit('keyup-next');
      }
    },

    /**
     * 切换认证方式
     */
    switchAuthMode() {
      this.$refs.formData.resetFields();
      this.clearCountDown(this.$t('i18n.sendCapt'));
      this.$router.push({
        query: {
          auth: this.isEmailAuth ? undefined : 'email',
        },
      });
      this.$nextTick(() => {
        // 切换后，聚焦第一个输入框
        this.$el.querySelector('input').focus();
      });
    },

    /**
         * 获取邮箱验证码
         */
    getEmailCaptcha() {
      this.$refs.formData.validateField('email', (error) => {
        if (error) {
          return;
        }
        // this.$refs.geetest.verify();
        this.sendEmailAjax();
      });
    },

    sendEmailAjax() {
      const { formData } = this;
      this.loading = true;
      this.$api.emailAuth.sendMessage({
        email: formData.email,
        stype: this.pageType === 'reset' ? 1 : 2,
        // challenge: this.g.initResult.geetest_challenge,
      }).then(() => {
        this.$message.success(this.$t('ajax.success'));
        this.$refs.emailCpt.focus();
        this.countDown(60, this.captchaText);
        this.captchaLoading = true;
      }).catch((err) => {
        if (err.CODE === 'GT_VERIFY_STATUS_NO_EXIST') {
          this.refreshInitGeetest();
        } else this.$refs.geetest.reset();
        this.clearCountDown(this.$t('i18n.sendCapt'));
      }).finally(() => {
        this.loading = false;
      });
    },

    gReset() {
      console.log('gReset');
      this.g = { ...this.gBase };
    },

    gOnClose() {
      console.log('gOnClose');
    },
    gOnError(res) {
      // 极验证详情错误码见@/assets/md/geetest.md文档
      if (res.code && res.code === 'error_1021') this.refreshInitGeetest(); // SESSION过期
      else if (res.error_code && res.error_code === 1021) {
        // 初始化后如果网络异常会出现1021错误码（每8分钟极验证会发起一个reset.php的xhr）
        this.refreshInitGeetest();
        this.$message({
          showClose: true,
          message: res.error_msg,
          type: 'warning',
        });
      } else if (res.error_code !== 1001 && res.error_code !== 1012) {
        // 1001 刷新次数过多 1021 拖动图像拼合错误次数过多
        this.$message({
          showClose: true,
          message: res.error_msg,
          type: 'warning',
        });
      }
    },

    gOnSuccess({ result, validate }) {
      this.g.initResult = result;
      this.g.validate = validate;
      this.formData.challenge = result.geetest_challenge;
      if (this.isEmailAuth) {
        this.sendEmailAjax();
      } else {
        this.sendPhoneAjax();
      }
    },

    gInitError() {
      console.log('gInitError');
    },

    reset() {
      this.$refs.geetest.reset();
      this.g = JSON.parse(JSON.stringify(this.gBase));
    },
    /**
         * 重新调用接口初始化极验证获取新session
         */
    refreshInitGeetest() {
      this.refreshGeetest = false;
      this.$nextTick(() => {
        this.refreshGeetest = true;
      });
    },
  },
};

</script>
